/**
 * PAN Entity Type Validation
 */

const PAN_REGEX = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

/**
 * Allowed PAN 4th-character mappings
 */
const PAN_CHAR_TO_ENTITY_TYPES = {
  P: ["proprietorship"],
  F: ["partnership", "llp"],
  C: ["private_limited", "public_limited"],
  T: ["trust"],
  A: ["society"],
};

/**
 * Labels
 */
const PAN_CHAR_LABEL = {
  P: "Individual / Proprietorship",
  F: "Partnership Firm / LLP",
  C: "Company (Pvt Ltd / Public Ltd)",
  T: "Trust",
  A: "Society / Association of Persons (AOP)",
};

/**
 * Validate PAN entity type
 */
export const validatePANEntityType = (pan, entityType) => {
  const pass = {
    isValid: true,
    message: "",
    panEntityChar: "",
    panEntityLabel: "",
  };

  if (!pan || !entityType) return pass;

  const cleaned = pan.trim().toUpperCase();

  // PAN format validation
  if (!PAN_REGEX.test(cleaned)) {
    return {
      isValid: false,
      message: "Invalid PAN format",
      panEntityChar: "",
      panEntityLabel: "",
    };
  }

  const panChar = cleaned[3];

  /**
   * NEW:
   * Only allow P/F/C/T/A
   */
  if (!PAN_CHAR_TO_ENTITY_TYPES[panChar]) {
    return {
      isValid: false,
      message: `Invalid PAN entity type character "${panChar}" in 4th position`,
      panEntityChar: panChar,
      panEntityLabel: "",
    };
  }

  const allowedTypes = PAN_CHAR_TO_ENTITY_TYPES[panChar];

  const panEntityLabel = PAN_CHAR_LABEL[panChar];

  const normalizedEntityType = entityType.trim().toLowerCase();

  const isValid = allowedTypes.includes(normalizedEntityType);

  if (!isValid) {
    return {
      isValid: false,
      message: `PAN 4th character "${panChar}" indicates ${panEntityLabel} — does not match selected entity type`,
      panEntityChar: panChar,
      panEntityLabel,
    };
  }

  return {
    isValid: true,
    message: "",
    panEntityChar: panChar,
    panEntityLabel,
  };
};
